import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, createVNode as _createVNode, vModelText as _vModelText, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "tx-narrow" }
const _hoisted_2 = { class: "tx-pagehead" }
const _hoisted_3 = ["onSubmit"]
const _hoisted_4 = { class: "tx-muted" }
const _hoisted_5 = { class: "tx-formrow" }
const _hoisted_6 = { class: "tx-field" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("option", { value: "en" }, "English", -1 /* HOISTED */)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("option", { value: "ar" }, "العربية", -1 /* HOISTED */)
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = { class: "tx-field" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("option", null, "System", -1 /* HOISTED */)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("option", null, "Light", -1 /* HOISTED */)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("option", null, "Dark", -1 /* HOISTED */)
const _hoisted_14 = [
  _hoisted_11,
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = { class: "tx-formrow" }
const _hoisted_16 = { class: "tx-field" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "—", -1 /* HOISTED */)
const _hoisted_18 = ["value"]
const _hoisted_19 = {
  key: 0,
  class: "tx-field"
}
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "tx-formactions" }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = ["onSubmit"]
const _hoisted_24 = ["onUpdate:modelValue"]
const _hoisted_25 = { class: "tx-formactions" }
const _hoisted_26 = ["disabled"]
const _hoisted_27 = {
  key: 0,
  class: "tx-card"
}
const _hoisted_28 = { class: "tx-row__main" }
const _hoisted_29 = ["onSubmit"]
const _hoisted_30 = { class: "tx-formrow" }
const _hoisted_31 = { class: "tx-field" }
const _hoisted_32 = { class: "tx-field" }
const _hoisted_33 = { class: "tx-field" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("option", null, "Self", -1 /* HOISTED */)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("option", null, "Billing", -1 /* HOISTED */)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("option", null, "Service", -1 /* HOISTED */)
const _hoisted_37 = [
  _hoisted_34,
  _hoisted_35,
  _hoisted_36
]
const _hoisted_38 = { class: "tx-formactions" }
const _hoisted_39 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", null, _toDisplayString($setup.state.t("settings.title")), 1 /* TEXT */)
    ]),
    _createVNode($setup["Loader"], {
      loading: $setup.loading,
      error: $setup.error,
      onRetry: $setup.load
    }, {
      default: _withCtx(() => [
        _createElementVNode("form", {
          class: "tx-card tx-form",
          onSubmit: _withModifiers($setup.saveProfile, ["prevent"])
        }, [
          _createElementVNode("h2", null, _toDisplayString($setup.state.t("settings.profile")), 1 /* TEXT */),
          _createElementVNode("p", _hoisted_4, _toDisplayString($setup.profile.full_name) + " · " + _toDisplayString($setup.profile.email), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("label", _hoisted_6, [
              _createElementVNode("span", null, _toDisplayString($setup.state.t("settings.language")), 1 /* TEXT */),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.profile.language) = $event))
              }, _hoisted_9, 512 /* NEED_PATCH */), [
                [_vModelSelect, $setup.profile.language]
              ])
            ]),
            _createElementVNode("label", _hoisted_10, [
              _createElementVNode("span", null, _toDisplayString($setup.state.t("settings.theme")), 1 /* TEXT */),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($setup.profile.theme) = $event))
              }, _hoisted_14, 512 /* NEED_PATCH */), [
                [_vModelSelect, $setup.profile.theme]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("label", _hoisted_16, [
              _createElementVNode("span", null, _toDisplayString($setup.state.t("settings.timezone")), 1 /* TEXT */),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($setup.profile.time_zone) = $event))
              }, [
                _hoisted_17,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.zones, (z) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: z,
                    value: z
                  }, _toDisplayString(z), 9 /* TEXT, PROPS */, _hoisted_18))
                }), 128 /* KEYED_FRAGMENT */))
              ], 512 /* NEED_PATCH */), [
                [_vModelSelect, $setup.profile.time_zone]
              ])
            ]),
            ($setup.state.orgs.length > 1)
              ? (_openBlock(), _createElementBlock("label", _hoisted_19, [
                  _createElementVNode("span", null, _toDisplayString($setup.state.t("settings.default_org")), 1 /* TEXT */),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($setup.profile.default_customer) = $event))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.orgs, (o) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: o.customer,
                        value: o.customer
                      }, _toDisplayString(o.customer_name), 9 /* TEXT, PROPS */, _hoisted_20))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 512 /* NEED_PATCH */), [
                    [_vModelSelect, $setup.profile.default_customer]
                  ])
                ]))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("button", {
              class: "tx-btn tx-btn--primary",
              disabled: $setup.busy
            }, _toDisplayString($setup.state.t("common.save")), 9 /* TEXT, PROPS */, _hoisted_22)
          ])
        ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_3),
        _createElementVNode("form", {
          class: "tx-card tx-form",
          onSubmit: _withModifiers($setup.savePrefs, ["prevent"])
        }, [
          _createElementVNode("h2", null, _toDisplayString($setup.state.t("settings.notifications")), 1 /* TEXT */),
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.PREF_KEYS, (k) => {
            return _createElementVNode("label", {
              key: k,
              class: "tx-check"
            }, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": $event => (($setup.prefs[k]) = $event),
                type: "checkbox",
                "true-value": 1,
                "false-value": 0
              }, null, 8 /* PROPS */, _hoisted_24), [
                [_vModelCheckbox, $setup.prefs[k]]
              ]),
              _createTextVNode(" " + _toDisplayString($setup.state.t("settings." + k)), 1 /* TEXT */)
            ])
          }), 64 /* STABLE_FRAGMENT */)),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("button", {
              class: "tx-btn tx-btn--primary",
              disabled: $setup.busy
            }, _toDisplayString($setup.state.t("common.save")), 9 /* TEXT, PROPS */, _hoisted_26)
          ])
        ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_23),
        ($setup.can('members.read'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
              _createElementVNode("h2", null, _toDisplayString($setup.state.t("settings.members")), 1 /* TEXT */),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.members, (m) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: m.user + m.access_level,
                  class: "tx-row"
                }, [
                  _createElementVNode("span", _hoisted_28, [
                    _createElementVNode("strong", null, _toDisplayString(m.full_name || m.user), 1 /* TEXT */),
                    _createElementVNode("small", null, _toDisplayString(m.user), 1 /* TEXT */)
                  ]),
                  _createVNode($setup["Badge"], {
                    label: m.access_level,
                    tone: m.enabled ? 'info' : 'muted'
                  }, null, 8 /* PROPS */, ["label", "tone"])
                ]))
              }), 128 /* KEYED_FRAGMENT */)),
              ($setup.can('members.request'))
                ? (_openBlock(), _createElementBlock("form", {
                    key: 0,
                    class: "tx-form tx-mt",
                    onSubmit: _withModifiers($setup.requestMember, ["prevent"])
                  }, [
                    _createElementVNode("h3", null, _toDisplayString($setup.state.t("settings.request_member")), 1 /* TEXT */),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("label", _hoisted_31, [
                        _createElementVNode("span", null, _toDisplayString($setup.state.t("settings.member_name")), 1 /* TEXT */),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($setup.member.full_name) = $event)),
                          required: "",
                          maxlength: "140"
                        }, null, 512 /* NEED_PATCH */), [
                          [_vModelText, $setup.member.full_name]
                        ])
                      ]),
                      _createElementVNode("label", _hoisted_32, [
                        _createElementVNode("span", null, _toDisplayString($setup.state.t("settings.member_email")), 1 /* TEXT */),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (($setup.member.email) = $event)),
                          type: "email",
                          required: ""
                        }, null, 512 /* NEED_PATCH */), [
                          [_vModelText, $setup.member.email]
                        ])
                      ]),
                      _createElementVNode("label", _hoisted_33, [
                        _createElementVNode("span", null, _toDisplayString($setup.state.t("settings.member_level")), 1 /* TEXT */),
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (($setup.member.access_level) = $event))
                        }, _hoisted_37, 512 /* NEED_PATCH */), [
                          [_vModelSelect, $setup.member.access_level]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("button", {
                        class: "tx-btn tx-btn--ghost",
                        disabled: $setup.busy
                      }, _toDisplayString($setup.state.t("common.submit")), 9 /* TEXT, PROPS */, _hoisted_39)
                    ])
                  ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_29))
                : _createCommentVNode("v-if", true)
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["loading", "error"])
  ]))
}